export class Items {
  ID: number;
  Position: number;
  Question: string;
  AnswerText: string;
  AnswerBool: boolean;
  Type: string;
}
